export default function(type: string) {
    switch (type) {
        case 'linkedin':
            window.sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on LinkedIn');
            break;
        case 'twitter':
            window.sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on Twitter');
            break;
        case 'facebook':
            window.sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on Facebook');
            break;
        case 'whatsapp':
            window.sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on WhatsApp');
            break;
        case 'email':
            window.sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on Email');
            break;
        case 'messenger':
            window.sendAnalyticsEvent('Editorial Engagement', 'Sharing', 'User Showed Intent to Share on Messenger');
            break;
        default:
    }
};
